import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { currentConfig } from "app.config";

import type { IMagicoAppData } from "../../models/AppConfigModels";

// Magico API configuration - separate from main baseApi to avoid conflicts
const MAGICO_BASE_URL = currentConfig.REACT_APP_MAGICO_URL;

const magicoBaseQuery = fetchBaseQuery({
  baseUrl: MAGICO_BASE_URL,
  prepareHeaders: (headers) => {
    headers.set("Content-Type", "application/json");
    return headers;
  },
});

interface GetLocaleKeysParams {
  id: number;
  type?: string;
}

export interface RemoteLocaleResponse {
  remoteLocaleKeys: Record<string, Record<string, string>>;
}

export const magicoApi = createApi({
  reducerPath: "magicoApi",
  baseQuery: magicoBaseQuery,
  tagTypes: ["magico-app-config", "locale-keys"],
  endpoints: (builder) => ({
    getAppById: builder.query<IMagicoAppData, number>({
      query: (id: number) => ({
        url: "/api/cms/getById",
        method: "POST",
        body: { id },
      }),
      providesTags: ["magico-app-config"],
    }),
    getLocaleKeys: builder.query<RemoteLocaleResponse, GetLocaleKeysParams>({
      query: ({ id}) => ({
        url: "/api/lang/getKeys",
        method: "GET",
        params: { id, type: "cms", returnType: "object" },
      }),
      providesTags: ["locale-keys"],
    }),
  }),
});

export const { useGetAppByIdQuery, useLazyGetAppByIdQuery, useLazyGetLocaleKeysQuery } = magicoApi;